export const sendMessage = ({method, data, resolve, reject, timeout}: {
    method: string,
    data?: any,
    resolve: (data: any) => void,
    reject: (error: any) => void,
    timeout: number
}) => {
    const messageId = window.matchProvider.sendWalletMessage({
        method,
        data
    })
    window.matchProvider.walletMessageMap[messageId] = {
        resolve,
        reject,
    }
    window.matchProvider.walletMessageMap[messageId].timeout = setTimeout(() => {
        console.error('Get wallet result timeout', {
            messageId,
            method,
            data
        })
        delete window.matchProvider.walletMessageMap[messageId]
        reject(new Error('Get wallet result timeout'))
    }, timeout)
}

export const retryMessage = (params: { method: string, data?: any, timeout?: number }, options?: {
    retryCount: number,
    retryInterval: number,
}): Promise<any> => {
    return new Promise((resolve, reject) => {
        let times = 0
        const getRes = async () => {
            times++
            if (times > (options?.retryCount || 10)) {
                reject(new Error('retryMessage timeout'))
                return
            }
            if (!window.matchProvider) {
                setTimeout(() => {
                    getRes()
                }, (options?.retryInterval || 600))
                return
            }
            const res = await window.matchProvider.waitUntilWalletMessage(params)
            resolve(res)
        }
        getRes()
    })
}
